import { render, staticRenderFns } from "./RealSearch.vue?vue&type=template&id=cd485e60&scoped=true&"
import script from "./RealSearch.vue?vue&type=script&lang=js&"
export * from "./RealSearch.vue?vue&type=script&lang=js&"
import style0 from "./RealSearch.vue?vue&type=style&index=0&id=cd485e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd485e60",
  null
  
)

export default component.exports